import { useLazyQuery, useQuery } from "@apollo/client/react"; import { useEffect, useState } from 'react';

import toast from 'react-hot-toast';
import { useVisita } from '../../../context/VisitaContext';
import { tipoArchivoVisita } from '../constants/TipoArchivosVisita';
import { GET_ARCHIVOS_VISITA } from '../../../data/graphQL/queries/MisVisitas/getArchivosVisita';

export const useArchivosVisita = (idVisita) => {
    const { setVisita } = useVisita();
    const [archivos, setArchivos] = useState([]);

    const [getArchivos, { data: dataArchivos }] = useLazyQuery(GET_ARCHIVOS_VISITA, {
        fetchPolicy: 'no-cache',
        skip: !idVisita
    });

    useEffect(() => {
        if (!dataArchivos) return;
        setArchivos(dataArchivos?.archivoVisitasById?.valorEsperado);
    }, [dataArchivos]);

    useEffect(() => {
        if (idVisita) {
            getArchivos({ variables: { idVisita } });
        }
    }, [idVisita]);

    useEffect(() => {
        if (dataArchivos?.archivoVisitasById?.valorEsperado) {
            setVisita((prev) => ({
                ...prev,
                firmaPaciente: archivos.find((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.FIRMA) || null,
                adjuntoCapacitacion: archivos.find((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.CAPACITACION) || null,
                fotoSonda: archivos.find((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.SONDA) || null,
                fotoPuerta: archivos.find((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.FOTO_VIVIENDA) || null,
                fotoPuertaAdjuntos: archivos.filter((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.FOTO_VIVIENDA) || [],
                conclusionPresencialAdjuntos: archivos.filter((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.DOCUMENTOS) || [],
                adjuntos: archivos.filter((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.DOCUMENTOS) || [],
                laboratorioAdjunto: archivos.find((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.LABORATORIO) || null,
                troquelAdjunto: archivos.find((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.TROQUELES) || null,
                informeVideodeglucion: archivos.find((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.LABORATORIO) || null,
                estudioAdjunto: archivos.filter((a) => a.idTipoArchivoDocumento === tipoArchivoVisita.ESTUDIO_COMPLEMENTARIO) || []
            }));
        }
    }, [archivos, setVisita]);
};